export default {
  labels: {
    free_items: 'Gratis items',
    bogo: 'Koop één, krijg één gratis',
    order_again: 'Opnieuw bestellen',
  },
};
